import { computed } from 'vue'
import { useStore } from 'vuex'

export function useAttr(system, path) 
{
  const store = useStore()
  const entity = store.getters.matchEntity(system, path)

  function getAttr(field) 
  {
    return computed(() => 
    {
      if (entity)
      {
        return store.getters.attr(system, entity, field)
      }
      else
      {
        return `no entity ${system}:${path}`
      }
    })
  }
  return { getAttr }
}
